export default __webpack_public_path__ + "static/media/b1.8756862a.svg";